import { render, staticRenderFns } from "./Tablet.vue?vue&type=template&id=ef191a4e&scoped=true&"
import script from "./Tablet.vue?vue&type=script&lang=js&"
export * from "./Tablet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef191a4e",
  null
  
)

export default component.exports